import * as React from 'react';
import AppDocumentTitle from '../Common/AppDocumentTitle/AppDocumentTitle';
import AppTitleUpdater from '../Common/AppTitleUpdater';
import AppFooterUpdater from '../Common/AppFooterUpdater';
import FormDialog from '../Common/Form/FormDialog/FormDialog';
import FormDialogFooter from '../Common/Form/FormDialog/FormDialogFooter';
import PrimaryButton from '../Common/Buttons/PrimaryButton';
import FormTitle from '../Common/Form/FormTitle/FormTitle';
import States from 'login-constants/states';
import { pushWithContext } from 'login-utils/routingUtils';
import './LoanEstimateExplanation.scss';

const goToAcceptTerms = evt => {
  evt.preventDefault();
  pushWithContext(States.LOAN_ESTIMATE_TERMS);
};

const goToCreateAccount = evt => {
  evt.preventDefault();
  pushWithContext(States.CREATE_ACCOUNT);
};

const buttons = [
  {
    text: 'Obtain a Loan Estimate',
    buttonId: 'it-ConfirmRequestLoanEstimate',
    onClick: goToAcceptTerms,
  },
  {
    text: 'Complete an Application',
    buttonId: 'it-CompleteApplication',
    onClick: goToCreateAccount,
  },
];

const explanationText =
  'Federal law requires we offer you the ability to obtain a Loan Estimate even if you provide limited information. Based only on limited information, we will have to make reasonable assumptions in providing your Loan Estimate, including whether you are applying for a purchase, refinance or home equity loan. If you provide more information up front through the full application process, we will provide you with a Loan Estimate that better reflects your needs. In addition, once you are ready to move forward with a full application additional information will be required. Regardless of whether you provide the limited information or a full application, you will receive a Loan Estimate.';

class LoanEstimateExplanation extends React.Component<{}, {}> {
  render() {
    return (
      <div className="LoanEstimateExplanation">
        <AppDocumentTitle title="Loan Estimate Explanation">
          <AppTitleUpdater text={null}>
            <AppFooterUpdater footerConfig={null}>
              <FormDialog>
                <div className="LoanEstimateExplanation-bodyWrapper">
                  <FormTitle text="Obtaining a Loan Estimate" />
                  <div className="LoanEstimateExplanation-detailText">{explanationText}</div>
                </div>
                <FormDialogFooter>
                  {buttons.map((buttonConfig, i) => (
                    <div className="LoanEstimateExplanation-buttonWrapper" key={i}>
                      <PrimaryButton {...buttonConfig} />
                    </div>
                  ))}
                </FormDialogFooter>
              </FormDialog>
            </AppFooterUpdater>
          </AppTitleUpdater>
        </AppDocumentTitle>
      </div>
    );
  }
}

export default LoanEstimateExplanation;
